module.exports = __webpack_public_path__ + "media/annarbor.19ca71a6.mp4";